class MCartDrawer extends HTMLElement {
    constructor() {
        super(),
        this.cartDrawerInner = this.querySelector(".m-cart-drawer__inner"),
        this.cartDrawerCloseIcon = this.querySelector(".m-cart-drawer__close"),
        this.cartOverlay = this.querySelector(".m-cart__overlay"),
        this.rootUrl = window.Shopify.routes.root,
        this.setHeaderCartIconAccessibility(),
        this.cartDrawerCloseIcon.addEventListener("click", this.close.bind(this)),
        this.addEventListener("click", (t=>{
            t.target.closest(".m-cart-drawer__inner") !== this.cartDrawerInner && this.close()
        }
        ))
    }
    setHeaderCartIconAccessibility() {
        document.querySelectorAll(".m-cart-icon-bubble").forEach((t=>{
            t.setAttribute("role", "button"),
            t.setAttribute("aria-haspopup", "dialog"),
            t.addEventListener("click", (e=>{
                MinimogSettings.enable_cart_drawer && (e.preventDefault(),
                this.open(t))
            }
            ))
        }
        ))
    }
    open(t) {
        t && this.setActiveElement(t),
        this.classList.add("m-cart-drawer--active"),
        requestAnimationFrame((()=>{
            this.style.setProperty("--m-bg-opacity", "0.5"),
            this.cartDrawerInner.style.setProperty("--translate-x", "0")
        }
        )),
        window.MinimogEvents.emit(MinimogTheme.pubSubEvents.openCartDrawer),
        document.documentElement.classList.add("prevent-scroll")
    }
    close() {
        this.style.setProperty("--m-bg-opacity", "0"),
        this.cartDrawerInner.style.setProperty("--translate-x", "100%"),
        setTimeout((()=>{
            this.classList.remove("m-cart-drawer--active"),
            document.documentElement.classList.remove("prevent-scroll")
        }
        ), 300)
    }
    renderContents(t) {
        this.classList.contains("m-cart--empty") && this.classList.remove("m-cart--empty"),
        this.productId = t.id,
        this.getSectionsToRender().forEach((e=>{
            (e.selector ? document.querySelector(e.selector) : document.getElementById(e.id)).innerHTML = this.getSectionInnerHTML(t.sections[e.id], e.selector)
        }
        )),
        setTimeout((()=>{
            this.open(),
            window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
        }
        ))
    }
    updateCartCount(t) {
        document.querySelectorAll(".m-cart-count-bubble").forEach((e=>{
            t > 0 ? (e.textContent = t,
            e.classList.remove("hidden")) : e.classList.add("hidden")
        }
        ))
    }
    getCart() {
        return fetchJSON(this.rootUrl + "cart.json")
    }
    onCartDrawerUpdate(t=!0,open) {
        fetch(`${MinimogSettings.routes.cart}?section_id=cart-drawer`).then((t=>t.text())).then((e=>{
                this.getSectionsToRender().forEach((r=>{
                    if ("cart-items" === r.block) {
                        (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector),
                        window.FoxKitV2 && window.FoxKitV2.Modules.InCart && window.FoxKitV2.Modules.InCart.getCart()
                    } else if (t) {
                        (r.selector ? document.querySelector(r.selector) : document.getElementById(r.id)).innerHTML = this.getSectionInnerHTML(e, r.selector)
                    }
                }
            ))
        }
        )).catch((t=>{}
        )),
        this.getCart().then((t=>{
            this.classList.toggle("m-cart--empty", 0 === t.item_count),
            this.updateCartCount(t.item_count)
        }
        ))
    }
    getSectionInnerHTML(t, e=".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e).innerHTML
    }
    getSectionsToRender() {
        return [{
            id: "cart-drawer",
            selector: "[data-minimog-cart-items]",
            block: "cart-items"
        }, {
            id: "cart-drawer",
            selector: "[data-minimog-cart-discounts]",
            block: "cart-footer"
        }, {
            id: "cart-drawer",
            selector: "[data-cart-subtotal]",
            block: "cart-footer"
        }, {
            id: "cart-drawer",
            selector: "[data-minimog-gift-wrapping]",
            block: "cart-footer"
        },{
            id: "cart-drawer",
            section: "cart-shipping-process",
            selector: "[data-minimog-cart-process]"
        }]
    }
    getSectionDOM(t, e=".shopify-section") {
        return (new DOMParser).parseFromString(t, "text/html").querySelector(e)
    }
    setActiveElement(t) {
        this.activeElement = t
    }
}
customElements.define("m-cart-drawer", MCartDrawer);
class MCartDrawerItems extends MCartTemplate {
    getSectionsToRender() {
        return [{
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-items]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-discounts]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-cart-subtotal]"
        }, {
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-gift-wrapping]"
        },{
            id: "MinimogCartDrawer",
            section: "cart-drawer",
            selector: "[data-minimog-cart-process]"
        }]
    }
}
customElements.define("m-cart-drawer-items", MCartDrawerItems);

class cartRecommendations extends MCartTemplate {
  constructor(parent) {
    super();
    this.parent = parent;
    this._swiper = null;
    this._observer = null;
    this._visibilityObserver = null;

    this.clickEvent();
  }

  /* ----------------------- helpers ----------------------- */
  waitUntil = (fn, { timeout = 4000, interval = 100 } = {}) =>
    new Promise((resolve, reject) => {
      const start = Date.now();
      const tick = () => {
        try {
          const val = fn();
          if (val) return resolve(val);
          if (Date.now() - start >= timeout) return reject(new Error('waitUntil timeout'));
          setTimeout(tick, interval);
        } catch (e) {
          reject(e);
        }
      };
      tick();
    });

  get swiperEl() {
    return this.querySelector('.cart-recommendations-js');
  }

  get nextEl() {
    return this.querySelector('.swiper-button-next');
  }
  get prevEl() {
    return this.querySelector('.swiper-button-prev');
  }
  get paginationEl() {
    return this.querySelector('.swiper-pagination');
  }

  /* ----------------------- ajax add ----------------------- */
  ajaxCart = async (id) => {
    try {
      const data = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: 1 })
      });
      return await data.json();
    } catch (e) {
      console.log(e);
    }
  };

  /* ----------------------- ui events ----------------------- */
  clickEvent = () => {
    const btns = this.querySelectorAll('.m-choose-button');
    const closebtns = this.querySelectorAll('.close-btn');
    const addBtns = this.querySelectorAll('.add-button');
    const swatchBtns = this.querySelectorAll('.swatch-item');
    const cart = document.querySelector('m-cart-drawer');

    swatchBtns.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const parent = e.target.closest('.product-container');
        const swatchWrap = e.target.closest('.swatch-wrap');
        swatchWrap.querySelectorAll('.swatch-item').forEach((i) => i.classList.remove('active'));
        e.target.classList.add('active');

        const option = swatchWrap.closest('.option-container');
        option.classList.add('active');

        const allOptions = parent.querySelectorAll('.option-container');
        let found = false;
        for (let i = 0; i < allOptions.length; i++) {
          const op = allOptions[i];
          if (!op.classList.contains('active')) {
            parent.querySelector('.add-button').innerHTML = op.querySelector('.option-name').innerHTML;
            found = true;
            break;
          }
        }

        if (!found) {
          parent.querySelector('.add-button').classList.add('active');
          const product = JSON.parse(parent.querySelector('.product-data').innerHTML);
          let variant = null;

          if (allOptions.length === 1) {
            variant = product.variants.find(
              (v) => v.option1 == allOptions[0]?.querySelector('.swatch-item.active')?.dataset?.value
            );
          } else if (allOptions.length === 2) {
            variant = product.variants.find(
              (v) =>
                v.option1 ==
                  allOptions[0]?.querySelector('.swatch-item.active')?.dataset?.value &&
                v.option2 ==
                  allOptions[1]?.querySelector('.swatch-item.active')?.dataset?.value
            );
          } else if (allOptions.length === 3) {
            variant = product.variants.find(
              (v) =>
                v.option1 ==
                  allOptions[0]?.querySelector('.swatch-item.active')?.dataset?.value &&
                v.option2 ==
                  allOptions[1]?.querySelector('.swatch-item.active')?.dataset?.value &&
                v.option3 ==
                  allOptions[2]?.querySelector('.swatch-item.active')?.dataset?.value
            );
          }

          if (variant) {
            if (variant.available) {
              parent.querySelector('.add-button').innerHTML = 'Add';
              parent.querySelector('.add-button').setAttribute('data-id', variant.id);
              parent.querySelector('.add-button').removeAttribute('disabled');
            } else {
              parent.querySelector('.add-button').innerHTML = 'Sold out';
              parent.querySelector('.add-button').setAttribute('disabled', true);
            }
          } else {
            parent.querySelector('.add-button').setAttribute('disabled', true);
            parent.querySelector('.add-button').innerHTML = 'Unavailable';
          }
        }
      });
    });

    btns.forEach((item) => {
      item.addEventListener('click', (e) => {
        e.preventDefault();
        const parent = e.target.closest('.product-container');
        const vSelector = parent.querySelector('.swatch-items');
        if (vSelector) vSelector.classList.add('active');
      });
    });

    closebtns.forEach((item) => {
      item.addEventListener('click', (e) => {
        const parent = e.target.closest('.product-container');
        const vSelector = parent.querySelector('.swatch-items');
        if (vSelector) vSelector.classList.remove('active');
      });
    });

    addBtns.forEach((item) => {
      item.addEventListener('click', async (e) => {
        const parent = e.target.closest('.product-container');
        if (!e.target.classList.contains('active')) return;

        await this.ajaxCart(e.target.dataset.id);

        const cart = document.querySelector('m-cart-drawer');
        if (cart?.onCartDrawerUpdate) cart.onCartDrawerUpdate();
        if (cart?.open) cart.open();
      });
    });
  };

  /* ----------------------- swiper lifecycle ----------------------- */
  initSwiper = () => {
    // Destroy if exists
    if (this._swiper && this._swiper.destroy) {
      try { this._swiper.destroy(true, true); } catch (_) {}
      this._swiper = null;
    }

    const container = this.swiperEl;
    if (!container) return;

    // Guard: need slides
    const slides = container.querySelectorAll('.swiper-slide');
    if (!slides.length) return;

    // Guard: lib not ready
    if (!window?.MinimogLibs?.Swiper) return;

    // Instantiate
    this._swiper = new MinimogLibs.Swiper(container, {
      slidesPerView: 1,
      spaceBetween: 10,
      freeMode: false,
      navigation: {
        nextEl: this.nextEl,
        prevEl: this.prevEl
      },
      pagination: {
        el: this.paginationEl,
        clickable: true
      },
      observer: true,        // observe children
      observeParents: true,  // observe parent size changes
      watchOverflow: true
    });

    // Final update after a tick (helps when drawer just opened)
    setTimeout(() => {
      try { this._swiper.update && this._swiper.update(); } catch (_) {}
    }, 50);
  };

  ensureAndInit = async () => {
    try {
      // Wait until lib + container + visibility
      await this.waitUntil(() => window?.MinimogLibs?.Swiper && this.swiperEl);
      // If element is hidden (drawer closed), defer init until visible
      const isVisible = this.offsetParent !== null || this.getClientRects().length > 0;
      if (!isVisible) return; // visibility observer will handle it
      this.initSwiper();
    } catch (e) {
      // swallow – not fatal
    }
  };

  attachObservers = () => {
    // Observe markup mutations inside this component (recommendations re-render)
    if (!this._observer) {
      this._observer = new MutationObserver(() => {
        // Re-init when slides/controls change
        this.ensureAndInit();
      });
      this._observer.observe(this, { childList: true, subtree: true });
    }

    // Observe visibility (e.g., cart drawer opens)
    if (!this._visibilityObserver) {
      this._visibilityObserver = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) this.ensureAndInit();
        });
      }, { root: null, threshold: 0.1 });
      this._visibilityObserver.observe(this);
    }

    // If your cart drawer dispatches a custom event on open/update, hook it here:
    // window.addEventListener('cart-drawer:open', () => this.ensureAndInit());
    // window.addEventListener('cart-drawer:updated', () => this.ensureAndInit());
  };

  /* ----------------------- web component hooks ----------------------- */
  connectedCallback() {
    // Set up observers immediately
    this.attachObservers();
    // Try once now (covers the “already open” case)
    this.ensureAndInit();
  }

  disconnectedCallback() {
    if (this._observer) { this._observer.disconnect(); this._observer = null; }
    if (this._visibilityObserver) { this._visibilityObserver.disconnect(); this._visibilityObserver = null; }
    if (this._swiper?.destroy) {
      try { this._swiper.destroy(true, true); } catch (_) {}
      this._swiper = null;
    }
  }
}

customElements.define('cart-recommendations', cartRecommendations);



class freeGift extends HTMLElement {
    constructor() {
        super();
        // if (parent.lenth == 0) {
        //     return
        // }
        this.product = window.freeGiftProduct;
        // this.parent = null;
        this.init();
    }

    ajaxCart = async(id) =>{
        try{
            let data = await fetch('/cart/add.js',{
                  method: "POST",
                  headers: {
                      'Content-Type': 'application/json'
                  },
                    body: JSON.stringify({
                        id:id, quantity:1
                    })
                });
            let res = await data.json();
            return res;
          }catch(e){
              console.log(e);
          }
    }

    getVariant = () =>{
        let selectors = this.querySelectorAll('.free-gift-select');
        let variant = null;
         if(selectors.length == 1){
            variant = this.product.variants.find((item)=> item.option1 == selectors[0].value);
            
         }else if(selectors.length == 2){
            variant = this.product.variants.find((item)=> item.option1 == selectors[0].value && item.option2 == selectors[1].value);
            
         }else if(selectors.length == 3){
            variant = this.product.variants.find((item)=> item.option1 == selectors[0].value && item.option2 == selectors[1].value && item.option3 == selectors[2].value);
         }
         return variant;
    }
    updateData = (variant) =>{
        console.log("variant",variant);
        let price = this.querySelector('.m-cart-item__price--regular');
        price.innerHTML = formatMoney(variant.price);
        let btn = this.querySelector('.free-add-btn');
        if(variant){
            if(variant.available){
                btn.removeAttribute('disabled');
                btn.innerHTML = 'Add';
                btn.setAttribute('data-id',variant.id);
            }else{
                btn.innerHTML = 'Sold out'
                btn.setAttribute('disabled', true);
            }
        }else{
            btn.innerHTML = 'Unavailable'
            btn.setAttribute('disabled', true);
        }
    }
    changeEvent = () => {
        let selectors = this.querySelectorAll('.free-gift-select');
        const cart = document.querySelector('m-cart-drawer')
        selectors.forEach(item => {
            item.addEventListener('change',(e)=>{
                setTimeout(()=>{
                    const variant = this.getVariant();
                    this.updateData(variant);
                },500)
            })
        })
        const freeGiftBtn = this.querySelector(".free-add-btn");
        freeGiftBtn.addEventListener('click',async (e)=>{
            // window.addFreegift(e.target);
            const data = await this.ajaxCart(e.target.dataset.id);
            cart.onCartDrawerUpdate();
            cart.open()
        })
    }

    init = () => {
        this.changeEvent();
    }
}
customElements.define("cart-free-gift", freeGift);
